import * as React from "react";
import { ReactNode } from "react";
import DatePicker from "react-datepicker";

export namespace Data {

    export type Quickscan = {
        type:string;
        organisation: string;
        address: string;
        zipcode: string;
        city: string;
        firstName: string;
        lastName: string;
        position: string;
        otherInfo: string;
        phoneNumber: string;
        foundingDate: Date;
        fte: number;
        previousRevenue: number;
        currentRevenue: number;
        category:string;
        activities:string;
        innovation:string;
        ip:string;
        amount:number;
        period:string;
        equipment: string;
        alternativeFunding: string;
        otherFinancing: string;
        nda: boolean;
        privacy: boolean;
        questions: string;
    }

    export type Validation = {
        fields: {
            organisation: boolean;
            address: boolean;
            zipcode: boolean;
            city: boolean;
            firstName: boolean;
            lastName: boolean;
            position: boolean;
            otherInfo: boolean;
            phoneNumber: boolean;
            fte: boolean;
            previousRevenue: boolean;
            currentRevenue: boolean;
            activities: boolean;
            innovation: boolean;
            ip: boolean;
            amount: boolean;
            equipment: boolean;
            alternativeFunding: boolean;
            otherFinancing: boolean;
            privacy: boolean;
        }
        steps: Array<boolean>;
    }

}


export namespace State {

    export type Quickscan = {
        quickscan: Data.Quickscan;
        validation: Data.Validation;
        currentStep: number;
        visited: Array<boolean>;
        finished: boolean;
        error: boolean;
    }

    export type Step = [
        number,
        React.Dispatch<React.SetStateAction<number>>
    ];

}

export namespace Props {

    type BaseProps = {
        children?: ReactNode;
    }

    export type QuickscanProvider = BaseProps;

    export type Loading = {
        title: string;
    }

    export type SaveButton = {
        status: string;
        label: string;
        type: 'primary' | 'secondary';
    }

}

export type ManageableQuickscanData = [State.Quickscan, React.Dispatch<Actions.QuickscanDataActions>];


export type Settings = {
    apiUrl: string;
    type: string;
}

export namespace Actions {

    export enum QuickscanDataTypes {
        SET_QUICKSCAN_DATA = 'SET_QUICKSCAN_DATA',
        VALIDATE_QUICKSCAN_STEP = 'VALIDATE_QUICKSCAN_STEP',
        SET_QUICKSCAN_STEP = 'SET_QUICKSCAN_STEP',
        FINISH_QUICKSCAN = 'FINISH_QUICKSCAN'
    }

    export type QuickscanDataActions = SetQuickscanDataAction | SetQuickscanStepAction | QuickscanValidateStepAction | QuickscanFinishedAction;

    export type SetQuickscanDataAction = {
        type: QuickscanDataTypes.SET_QUICKSCAN_DATA;
        payload: {
            quickscan: Data.Quickscan;
        };
    }

    export type SetQuickscanStepAction = {
        type: QuickscanDataTypes.SET_QUICKSCAN_STEP;
        payload: {
            step: number;
        };
    }

    export type QuickscanValidateStepAction = {
        type: QuickscanDataTypes.VALIDATE_QUICKSCAN_STEP;
        payload: {
            step: number;
        };
    }

    export type QuickscanFinishedAction = {
        type: QuickscanDataTypes.FINISH_QUICKSCAN;
        payload: {
            finished: boolean;
            error: boolean;
        };
    }
}


export namespace API {

    export enum Actions {
        QUICKSCAN_POST = "curriculum_wizard_get",
    }

    export type Args = {
        post_id?: number;
        cluster_slug?: string;
        zmp_media_wpnonce?: string;
    }

}

export namespace Errors {

    export type GenericError = {
        status: string;
        message: string;
    };

    export type RetrievingDataFailed = {
        success: boolean;
        err: string;
    };

}

